/**
 * 사용자 구독·사용량 API.
 */

import { apiService } from './api'

export interface SubscriptionInfo {
  plan: string
  status?: string
  startDate?: string
  endDate?: string
  billing?: string
  amount?: number
  [key: string]: unknown
}

export interface UsageInfo {
  usedLinks: number
  usedClicks: number
  monthlyLinkLimit: number
  monthlyClickLimit: number
  [key: string]: unknown
}

export interface AvailablePlan {
  type: string
  displayName: string
  price: { monthly: number; yearly: number }
  [key: string]: unknown
}

interface ApiEnvelope<T> {
  success: boolean
  data?: T
  message?: string
}

export const userAccountApi = {
  /** 구독 정보. 호출부가 화면에서 쓰는 실제 응답 타입을 지정할 수 있다. */
  async getSubscription<T = SubscriptionInfo>(): Promise<T | null> {
    const response = await apiService.client.get<ApiEnvelope<T>>(
      '/users/subscription'
    )
    return response.data.data ?? null
  },

  async getUsage<T = UsageInfo>(): Promise<T | null> {
    const response = await apiService.client.get<ApiEnvelope<T>>('/users/usage')
    return response.data.data ?? null
  },

  async getAvailablePlans<T = AvailablePlan[]>(): Promise<T | null> {
    const response = await apiService.client.get<ApiEnvelope<T>>(
      '/users/subscription/available-plans'
    )
    return response.data.data ?? null
  },

  /** 플랜 변경. 다운그레이드 시 사용량 초과 경고가 data.warnings 로 온다. */
  async changePlan(input: {
    planId?: string
    planType?: string
    billing?: 'monthly' | 'yearly'
  }): Promise<ApiEnvelope<{ warnings?: string[] }>> {
    const response = await apiService.client.post<
      ApiEnvelope<{ warnings?: string[] }>
    >('/users/subscription/change-plan', input)
    return response.data
  },

  /** 공개 요금제 (비로그인에서도 조회) */
  async getPublicPlans(): Promise<AvailablePlan[]> {
    const response = await apiService.client.get<{
      success: boolean
      plans?: AvailablePlan[]
      data?: AvailablePlan[]
    }>('/plans/public')
    return response.data.plans ?? response.data.data ?? []
  },
}

export default userAccountApi
